import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import {TRANSACTION_TYPES} from "../../../../services/api/transactions-service";
import Icon from "../../../../components/icons/icon/icon";
import IconBankAccount from "../../../../components/icons/icon-bank-account/icon-bank-account";
import IconCreditCard from "../../../../components/icons/icon-credit-card/icon-credit-card";
import IconSwitchToExchange from "../../../../components/icons/icon-switch-to-exchange/icon-switch-to-exchange";
import { Tooltip } from "../../../../components/tooltip/tooltip";
import './amount.scss'
import { ReactNode } from "react";

interface IAmount {
    value: ReactNode;
    negative?: boolean;
    transaction_type_id?: number;
    is_incentive?: boolean;
}

const Amount: React.FC<IAmount> = ({ value, negative = false, transaction_type_id, is_incentive = false }) => {
    const color = negative ? FONT_COLOR.SEMANTIC_DANGER : FONT_COLOR.PRIMARY2;
    let icon = null;

    if (transaction_type_id === TRANSACTION_TYPES.REFUND_TO_BANK) {
        icon = <Icon Component={IconBankAccount} />;
    }
    if (transaction_type_id === TRANSACTION_TYPES.INSTANT_REFUND_TYPE || transaction_type_id === TRANSACTION_TYPES.ORIG_PAYMENT) {
        icon = <Icon Component={IconCreditCard} />;
    }
    if (is_incentive) {
        icon = <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Switch to Exchange incentive bonus</FontBody2>}><Icon Component={IconSwitchToExchange} /></Tooltip>;
    }

    return (
        <div className={"amount"}>
            {icon}
            <FontBody2 variant={FONT_VARIANT.BOLD} color={color}>
                {value}
            </FontBody2>
        </div>
    );
}

export default Amount;
